export default "__VITE_ASSET__C2l1VNHe__"